import React, { useEffect, useRef, useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup'; // For validation
import styles from './profilebody.module.css';
import api from '../../../../Website/utils/api';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { upadteCustomerProfileThunk } from '../../../../Website/redux/customerSlice';
import { getManufacturerThunk } from '../../../../Website/redux/vendorSlice';

const AccountSettings = () => {
    const [loading, setLoading] = useState(false)
    const [isManufacturerMenuOpen, setManufacturerMenuOpen] = useState(false);
    const manufacturerMenuRef = useRef(null);

    const {basicDetailsLoading,customer} = useSelector((state)=>state.customer)
    const { manufacturers = [] } = useSelector((state) => state.vendor);
       

    // console.log(customer?.fullName);
    
    const dispatch = useDispatch()
    const imageRef = useRef()
    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            fullName: customer?.fullName || '',
            email:customer?.email || '',
            phone:customer?.phone || '',
            companyName:customer?.companyName || '',
            gstn:customer?.gstn || '',
            profileImg:customer?.profileImg || '',
            manufacturers: (customer?.manufacturers || []).map((manufacturer) =>
                typeof manufacturer === 'string' ? manufacturer : manufacturer?._id
            ).filter(Boolean)
        },
        validationSchema: Yup.object({
            fullName: Yup.string().required('Full Name is required'),
            email: Yup.string().email('Invalid email format').required('Email is required'),
            phone: Yup.string().required('Phone number is required'),
            companyName: Yup.string(),
            gstn: Yup.string(),

        }),
        onSubmit: (values) => {
            const { profileImg, ...basicDetails } = values;
            dispatch(upadteCustomerProfileThunk(
                profileImg ? { ...basicDetails, profileImg } : basicDetails
            ));
        },
    });

    useEffect(() => {
        if (customer?.userType === 'VENDOR') {
            dispatch(getManufacturerThunk());
        }
    }, [customer?.userType, dispatch]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (manufacturerMenuRef.current && !manufacturerMenuRef.current.contains(event.target)) {
                setManufacturerMenuOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const selectedManufacturerIds = formik.values.manufacturers || [];

    const toggleManufacturer = (manufacturerId) => {
        const isSelected = selectedManufacturerIds.includes(manufacturerId);
        formik.setFieldValue(
            'manufacturers',
            isSelected
                ? selectedManufacturerIds.filter((id) => id !== manufacturerId)
                : [...selectedManufacturerIds, manufacturerId]
        );
    };

    const selectedManufacturerNames = manufacturers
        .filter((manufacturer) => selectedManufacturerIds.includes(manufacturer?._id))
        .map((manufacturer) => manufacturer?.name);

 
    const handleImageChange = async (e, attribute) => {

        const file = e.target?.files?.[0] || e.dataTransfer?.files?.[0];

        setLoading(true);
        try {
            if (file) {

                const body = {
                    key: `${Date.now()}_${file.name}`,
                    fileType: file.type,
                    fileName: file.name,
                };

                const { data, status } = await api.getPutSignedUrl(body);
                // console.log(data);

                if (status === 200) {
                    await axios.put(data.data?.preSigned, file, {
                        headers: {
                            "Content-Type": file.type
                        }
                    })

                    formik.setFieldValue('profileImg', data?.data?.url)
                    
                    const updatedValues = {
                        fullName: formik.values.fullName || customer?.fullName || '',
                        email: formik.values.email || customer?.email || '',
                        phone: formik.values.phone || customer?.phone || '',
                        companyName: formik.values.companyName || customer?.companyName || '',
                        gstn: formik.values.gstn || customer?.gstn || '',
                        profileImg: data?.data?.url
                    };
                    dispatch(upadteCustomerProfileThunk(updatedValues));
                }
            }
        } catch (err) {
            console.log(err);
            toast.error("Error uploading file")
        } finally {

            setLoading(false);
        }
    };

    const handleRemove = (repo) => {
        formik.setFieldValue(repo, '');
    };

    return (
        <div className={`${styles.profilebodyContainer} ${styles.acPolish} ${styles.accountSettingsCard}`}>
            <div className={styles.profileheader}>
                <h2>Account Settings</h2>
                <p className={styles.acSubtitle}>Update your personal and company details.</p>
            </div>
            <form onSubmit={formik.handleSubmit} className={styles.profilebodyContent}>
                <div className={styles.profilebodyDetails}>
                    <div className={styles.acGrid}>
                    <div>
                        <label htmlFor="fullName">Full Name</label>
                        <input
                            type="text"
                            id="fullName"
                            name="fullName"
                            placeholder='Enter your full name'
                            value={formik.values.fullName}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                        />
                        {formik.touched.fullName && formik.errors.fullName ? (
                            <div className={styles.error}>{formik.errors.fullName}</div>
                        ) : null}
                    </div>

                    <div>
                        <label htmlFor="email">Email</label>
                        <input
                            type="email"
                            id="email"
                            name="email"
                            placeholder='name@company.com'
                            value={formik.values.email}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                        />
                        {formik.touched.email && formik.errors.email ? (
                            <div className={styles.error}>{formik.errors.email}</div>
                        ) : null}
                    </div>

                    <div>
                        <label htmlFor="phone">Phone Number</label>
                        <input
                            type="tel"
                            id="phone"
                            name="phone"
                            placeholder='Enter phone number'
                            value={formik.values.phone}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                        />
                        {formik.touched.phone && formik.errors.phone ? (
                            <div className={styles.error}>{formik.errors.phone}</div>
                        ) : null}
                    </div>

                    <div>
                        <label htmlFor="companyName">Company</label>
                        <input
                            type="text"
                            id="companyName"
                            name="companyName"
                            placeholder='Enter company name'
                            value={formik.values.companyName}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                        />
                        {formik.touched.companyName && formik.errors.companyName ? (
                            <div className={styles.error}>{formik.errors.companyName}</div>
                        ) : null}
                    </div>

                    <div>
                        <label htmlFor="gstn">GST</label>
                        <input
                            type="text"
                            id="gstn"
                            name="gstn"
                            placeholder='Enter GST number'
                            value={formik.values.gstn}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                        />
                        {formik.touched.gstn && formik.errors.gstn ? (
                            <div className={styles.error}>{formik.errors.gstn}</div>
                        ) : null}
                    </div>
                    </div>

                    {customer?.userType === 'VENDOR' && (
                        <div className={styles.manufacturerField} ref={manufacturerMenuRef}>
                            <label>Manufacturer Selections</label>
                            <button
                                type="button"
                                className={styles.manufacturerSelect}
                                onClick={() => setManufacturerMenuOpen((isOpen) => !isOpen)}
                                aria-expanded={isManufacturerMenuOpen}
                            >
                                <span>
                                    {selectedManufacturerNames.length
                                        ? `${selectedManufacturerNames.length} manufacturer${selectedManufacturerNames.length > 1 ? 's' : ''} selected`
                                        : 'Select manufacturers'}
                                </span>
                                <span aria-hidden="true">⌄</span>
                            </button>

                            {isManufacturerMenuOpen && (
                                <div className={styles.manufacturerMenu}>
                                    {manufacturers.map((manufacturer) => (
                                        <label key={manufacturer?._id} className={styles.manufacturerOption}>
                                            <span>{manufacturer?.name}</span>
                                            <input
                                                type="checkbox"
                                                checked={selectedManufacturerIds.includes(manufacturer?._id)}
                                                onChange={() => toggleManufacturer(manufacturer?._id)}
                                            />
                                        </label>
                                    ))}
                                </div>
                            )}

                            {selectedManufacturerNames.length > 0 && (
                                <div className={styles.manufacturerTags}>
                                    {selectedManufacturerNames.map((name) => (
                                        <span key={name} className={styles.manufacturerTag}>{name}</span>
                                    ))}
                                </div>
                            )}
                            <small className={styles.manufacturerHint}>You can select multiple manufacturers.</small>
                        </div>
                    )}

                    <div className={styles.acActions}>
                        <button type="submit" className={styles.savechanges} disabled={basicDetailsLoading}>
                            {basicDetailsLoading ? 'Please wait...' : 'Save Changes'}
                        </button>
                    </div>
                </div>


            </form>
        </div>
    );
};

export default AccountSettings;
